<div
	@sideNavAnimation
	class="flex h-full w-full flex-col justify-center gap-6 border-r border-solid border-outline-alt bg-background p-4 group-hover/menu:shadow-lg max-2xl:group-hover/menu:bg-background"
	(mouseleave)="$openAddMenu.set(false)"
>
	<div class="flex h-full w-full flex-col justify-center gap-6">
		<!-- LOGO -->
		<button
			class="flex w-10 cursor-pointer flex-row items-center justify-center transition-all duration-200 max-2xl:group-hover/menu:w-full 2xl:w-full"
			aria-label="Tableau de bord"
			(click)="goToDashboard()"
		>
			@switch ($branding()) {
				@case (AgatheYouBranding.AY) {
					<img
						src="/static-assets/imgs/agathe-you/logo-ay.svg"
						alt=""
						class="z-10 h-10 w-10"
					/>
					<img
						src="/static-assets/imgs/agathe-you/logo-text-ay.svg"
						alt=""
						class="side-nav-agathe-you-img"
					/>
				}
				@case (AgatheYouBranding.CARE) {
					<img
						[src]="AgatheYouCareAssets.LOGO_PICTO"
						alt=""
						class="z-10 h-10 w-auto"
					/>
					<img
						[src]="AgatheYouCareAssets.LOGO_TEXT"
						alt=""
						class="side-nav-agathe-you-img side-nav-agathe-you-img-care"
					/>
				}
				@default {
					<span
						class="h-10 w-10"
						aria-hidden="true"
					></span>
				}
			}
		</button>

		@if ($showAddMenuToogle()) {
			@if ($loading()) {
				<div class="side-nav-actions-btn cursor-wait bg-secondary-container"></div>
			} @else {
				<button
					class="side-nav-actions-btn bg-secondary-container hover:shadow-lg"
					[class.shadow-lg]="$openAddMenu()"
					(click)="$openAddMenu.set(!$openAddMenu())"
				>
					<div class="flex h-full w-full cursor-pointer flex-row items-center justify-center">
						<span class="side-nav-actions-btn-text"> Actions </span>
						<div class="transition-all duration-200 max-2xl:group-hover/menu:opacity-100">
							<uikit-icon
								class="font-medium duration-100 max-2xl:group-hover/menu:scale-75 2xl:scale-75"
								[class.rotate-45]="$openAddMenu()"
								name="plus"
								size="default"
								fill="on-secondary-container"
							/>
						</div>
					</div>

					<cba-side-nav-actions-menu
						[fullClient]="$fullClient()"
						[(opened)]="$openAddMenu"
					/>
				</button>
			}
		}

		<!-- MENU ITEMS -->
		<div class="flex h-full w-full flex-col gap-2">
			<div class="flex flex-col gap-3">
				@if ($loading()) {
					@for (item of [0, 1, 2, 3, 4]; track item) {
						<div
							class="flex h-10 w-10 animate-pulse cursor-wait items-center justify-center rounded-full bg-primary-container text-on-background-alt max-2xl:group-hover/menu:w-full"
						></div>
					}
				} @else {
					@for (item of $menuItems(); track item.id) {
						<div class="relative w-full">
							<!-- A SUPPRIMER PLUS TARD QUAND LES PINS FONCTIONNERONT DANS L'UI-KIT -->
							@if (item.id === SideNavIds.PAIEMENT) {
								<app-paiement-menu-item
									[item]="item"
									(action)="onMenu($event)"
								/>
							} @else {
								<uikit-menu-item
									class="w-full"
									(action)="onMenu($event)"
									(click)="onMenu(item.link)"
									[item]="item"
								/>
							}
						</div>
					}
				}
			</div>

			@if ($hasHorizonComptaRole()) {
				<uikit-divider
					@itemEnterAnimation
					class="max-2xl:group-hover/menu:mx-1 2xl:mx-1"
				/>

				<button
					class="uikit-transition relative flex w-full cursor-pointer flex-row items-center gap-3 rounded-full pr-0 duration-200 hover:bg-primary-container group-hover/menu:w-full max-2xl:w-10"
					(click)="openHorizonCompta()"
					@itemEnterAnimation
				>
					<div
						class="min-h-10 min-w-10 flex items-center justify-center rounded-full bg-primary-container text-on-background-alt"
					>
						<img
							src="/static-assets/imgs/horizon-compta.svg"
							alt="Horizon Compta"
							class="min-h-6 min-wAjout d’un effet hover sur le bouton action-6 p-2"
						/>
					</div>
					<div
						class="uikit-menu-item-label uikit-transition z-0 mr-3 overflow-hidden whitespace-nowrap pl-0 text-on-background opacity-100 duration-200 group-hover/menu:mr-3 group-hover/menu:w-auto group-hover/menu:opacity-100"
					>
						Horizon Compta
					</div>
				</button>
			}
		</div>

		<div class="flex flex-col content-end gap-3">
			<div id="intercom-angular">
				<uikit-menu-item
					class="w-full"
					[item]="intercomMenuItem"
					(action)="onMenuContact($event)"
				/>
			</div>

			@if ($canReportBug()) {
				<uikit-button
					@itemEnterAnimation
					color="accent"
					size="small"
					radius="full"
					class="side-nav-bug-report"
					(action)="onReportBug()"
				>
					<uikit-icon
						name="bug"
						size="small"
						fill="on-secondary-container"
						class="absolute left-1 max-2xl:group-hover/menu:relative max-2xl:group-hover/menu:left-0 2xl:relative"
					/>
					<span class="side-nav-bug-report-text"> Reporter un bug </span>
				</uikit-button>
			}
		</div>
	</div>
</div>
